import React, { useEffect, useRef, useState } from "react";
import Constants from "expo-constants";
import { Button, StatusBar } from "react-native";
import * as Font from "expo-font";
import * as SplashScreen from "expo-splash-screen";
import { createAppContainer } from "react-navigation";
import { isSignedIn } from "./src/services/auth-service";
import * as Notifications from "expo-notifications";

import { createRootNavigator } from "./src/routes";

export default function App() {
  const [signed, setSigned] = useState(false);
  const [signLoaded, setSignLoaded] = useState(false);
  const [fontLoaded, setFontLoaded] = useState(false);

  const [expoPushToken, setExpoPushToken] = useState("");
  const [notification, setNotification] = useState(false);
  const notificationListener = useRef();
  const responseListener = useRef();

  StatusBar.setBarStyle("dark-content");

  useEffect(() => {
    const preLoad = async () => {
      await SplashScreen.preventAutoHideAsync();
      await Font.loadAsync({
        Montserrat: {
          uri: require("./assets/fonts/Montserrat-Regular.ttf"),
          display: Font.FontDisplay.FALLBACK,
        },
        "Montserrat-Medium": require("./assets/fonts/Montserrat-Medium.ttf"),
        "Montserrat-BlackItalic": require("./assets/fonts/Montserrat-BlackItalic.ttf"),
        "Montserrat-Italic": require("./assets/fonts/Montserrat-Italic.ttf"),
        "Montserrat-Light": require("./assets/fonts/Montserrat-Light.ttf"),
      });

      setFontLoaded(true);

      isSignedIn()
        .then((res) => {
          setSigned(res);
          setSignLoaded(true);
        })
        .catch((err) => console.log(err));

      await SplashScreen.hideAsync();
    };

    preLoad();
  }, []);

  if (!signLoaded) {
    return null;
  }

  const Layout = createRootNavigator(signed);
  const App = createAppContainer(Layout);
  return (
    <>
      <App />
    </>
  );
}
